import { baseGeospatial } from "../../../api/base/baseUrl";

const BASE_URL = "/api/v1/pricing-base";

export async function getPricingBaseListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function createPricingBaseRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updatePricingBaseRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}
